var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8285 5.83644L18.1642 1.17163C17.4141 0.421375 16.3968 0 15.3358 0H4C1.79087 0 0 1.79075 0 4L0.00125 28C0.00125 30.209 1.79212 32 4.00125 32H20C22.1999 32 24 30.1999 24 28V8.66506C24 7.604 23.5786 6.58644 22.8285 5.83644ZM21.0001 28C21.0001 28.5523 20.5524 29 20.0001 29H4.00112C3.44875 29 3.00113 28.5523 3.00113 28L3 4.00781C3 3.45556 3.44775 3.00781 4 3.00781H14.0005V8C14.0005 9.1045 14.8959 10 16.0005 10H21.0001V28ZM5.9425 22.5579C5.82031 22.6799 5.73706 22.8357 5.70312 23.0051L5.00894 26.4766C4.94775 26.7825 5.21762 27.0525 5.52369 26.9912L8.9955 26.2969C9.16481 26.2629 9.32031 26.1799 9.4425 26.0576L15.5434 19.9575L12.0431 16.4571L5.9425 22.5579ZM13.4571 15.043L16.9575 18.5434L18.4876 17.0137C19.171 16.3303 19.1711 15.2222 18.4877 14.5388L17.4619 13.5129C16.7786 12.8296 15.6706 12.8296 14.9872 13.5129L13.4571 15.043Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7a8a6171.svg";
export { ForwardRef as ReactComponent };